import { BiddingBidSendStatus } from '@ebalance/proto/bffuser/v1/bidding_common_model_pb'

import { isDraftWithSendErrorReason } from '~/models/bidDraftReturnReason'
import type { SpotBidRow } from '~/pages/SpotBidding/models/spotBidRow'
import type { SpotBidStatusCategory } from '~/pages/SpotBidding/models/spotBidStatusCategory'

/**
 * 送信軸が失敗系の時に、 送れない理由の tooltip を添える区分 (AC-BSP-011 / AC-BSP-117)。
 * 送り直している送信中と、 送れないまま締切を迎えた失効。 前の送信が受け付けられて
 * 約定結果を持つ札 (区分は全約定・部分約定・未約定) は、 送信軸が失敗のままでも添えない
 * (時間前の `STATUSES_WITH_SEND_ERROR_REASON` と同じく区分で絞る)。
 */
const CATEGORIES_WITH_SEND_ERROR_REASON: ReadonlySet<SpotBidStatusCategory> =
  new Set(['sending', 'expired'])

/**
 * 通常入札の一覧で、 ステータス列のバッジに送れない理由の tooltip を添えるか (#12494)。
 * 送る前に下書きに戻した札と、 承認軸が提出済のまま締切前に送れず区分が下書きになった札
 * (`sendFailedBeforeDeadlineCategory`) にも添える (AC-BSP-117)。 原因が未供給なら
 * tooltip 側がバッジだけを出す。
 */
export const hasSpotSendErrorReason = (
  row: Pick<SpotBidRow, 'approvalState' | 'sendStatus' | 'sendErrorCategory'>,
  category: SpotBidStatusCategory,
): boolean =>
  (CATEGORIES_WITH_SEND_ERROR_REASON.has(category) &&
    (row.sendStatus === BiddingBidSendStatus.SEND_FAILED ||
      row.sendStatus === BiddingBidSendStatus.SEND_FAILED_FINAL)) ||
  (category === 'draft' &&
    (isDraftWithSendErrorReason(row) ||
      row.sendStatus === BiddingBidSendStatus.SEND_FAILED_FINAL))
